import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { Divider, Grid, MenuItem, Typography } from "@mui/material";

import { useAxios, useComponent } from "../../../hooks";
import TextField from "./../../../components/TextField";
import { ComponentHeader, Paper } from "../../../components";
import BodyVariable from "./template details components/BodyVariable";
import HeaderVariable from "./template details components/HeaderVariable";
import ButtonVariable from "./template details components/ButtonVariable";
import AutocompleteMultiSelect from "../../../components/MultiselectAutoComplete";
import convertDateToBackendFormat from "./../../push notification components/push notification details components/convertDateToBackendFormat";

export function TemplateDetails({ formikProps, editState }) {
  const axios = useAxios();
  const { activeBot } = useSelector((state) => state.memberDetails);

  const [fields, setFields] = useState([]);
  const [template, setTemplate] = useState([]);
  const [showVar, setShowVar] = useState(false);
  const [templateData, setTemplateData] = useState({});
  const [scheduledTime, setScheduledTime] = useState([]);

  useEffect(() => {
    axios({
      url: "/wa/template/" + activeBot.ID + "?is_active=1&verified_status=3",
      method: "GET",
    }).then((response) => {
      if (response.status) {
        setTemplate(response.data.temp_obj);
      }
    });

    axios({
      url:
        "/custom_fields/get_fields_for_agent?agent_id=" +
        activeBot.ID +
        "&is_active=1",
      method: "GET",
    }).then((response) => {
      if (response.status) {
        let filterColumns = [
          {
            name: "name",
            label: "Name",
            dataType: "string",
          },
          {
            name: "email",
            label: "Email",
            dataType: "string",
          },
          {
            name: "phone",
            label: "Phone",
            dataType: "string",
          },
          {
            name: "created_by",
            label: "Created By",
            dataType: "string",
          },
        ];
        for (let field of response.data) {
          filterColumns.push({
            name: field.name,
            label: field.label,
            dataType: field.value_type,
            ...(field.control_id === "61dd2dfa1fb38be82e077ed8" && {
              options: field.options,
            }),
          });
        }
        setFields(filterColumns);
      }
    });
  }, [axios, activeBot.ID]);

  useEffect(() => {
    if (
      formikProps.values.createdAt &&
      formikProps.values?.templateID.length &&
      template.length
    ) {
      formikProps.values?.templateID.forEach((item) => {
        let templateName = template.filter((i) => item == i._id)[0].name;

        axios({
          url: "/wa/template/variable/" + activeBot.ID + "/" + item,
          method: "GET",
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            setTemplateData((prevData) => ({
              ...prevData,
              [templateName]: response.data,
            }));

            setShowVar(true);
          }
        });
      });
    }
  }, [
    template,
    axios,
    activeBot.ID,
    formikProps.values?.templateID,
    formikProps.values.createdAt,
  ]);

  useEffect(() => {
    axios({
      url: "/broadcast/time",
      method: "GET",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setScheduledTime(response.data);
      }
    });
  }, []);

  return (
    <Paper>
      <Grid item xs={12}>
        <ComponentHeader
          title={"Template Details"}
          subtitle={"Enter details for creating broadcast"}
        />
      </Grid>

      <Grid item xs={12} mb={5}>
        <AutocompleteMultiSelect
          name="templateID"
          label="Select Template"
          defaults={{
            primaryKey: "_id",
            displayLabel: "name",
          }}
          onClose={handleRenderVariable}
          options={template}
          onChange={(_, arr, reason, option) =>
            handleChangeTemplate(arr, option, reason, "templateID", "name")
          }
          formikProps={formikProps}
          disabled={!editState}
        />
      </Grid>

      {showVar &&
        Object.keys(templateData).map((data, index) => (
          <Fragment>
            <Grid item xs={6}>
              <Typography variant="h4">{data}</Typography>
            </Grid>

            <Fragment>
              <Grid item xs={3}>
                <TextField
                  type="date"
                  name={`${templateData[data].template_data.name}.broadcastDate`}
                  label="Select Date"
                  onChange={(e) =>
                    handleChange(e, templateData[data].template_data.name)
                  }
                  formikProps={formikProps}
                  inputProps={{
                    min: new Date().toISOString().split("T")[0],
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  disabled={!editState}
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  select
                  label="Select Time"
                  name={`${templateData[data].template_data.name}.broadcastTime`}
                  formikProps={formikProps}
                  size="small"
                  disabled={!editState}
                >
                  {scheduledTime.map((item, index) => {
                    return (
                      <MenuItem
                        key={item._id}
                        value={
                          index + 1 == scheduledTime.length
                            ? "23:59"
                            : scheduledTime[index + 1].time
                        }
                      >
                        {item.time} -{" "}
                        {`${
                          index + 1 == scheduledTime.length
                            ? "23:59"
                            : scheduledTime[index + 1].time
                        }`}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
            </Fragment>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {Boolean(templateData[data].variables.body.length) && (
              <Grid item xs={12}>
                <BodyVariable
                  data={data}
                  dialogFormikProps={formikProps}
                  templateData={templateData[data]}
                  formikProps={{
                    values: {
                      templateID: formikProps.values.templateID,
                    },
                  }}
                  fields={fields}
                  editState={editState}
                />
              </Grid>
            )}

            {Boolean(templateData[data].variables.header.length) && (
              <Grid item xs={12}>
                <HeaderVariable
                  data={data}
                  dialogFormikProps={formikProps}
                  templateData={templateData[data]}
                  formikProps={{
                    values: {
                      templateID: formikProps.values.templateID,
                    },
                  }}
                  fields={fields}
                  editState={editState}
                />
              </Grid>
            )}

            {Boolean(templateData[data].variables.button.length) && (
              <Grid item xs={12}>
                <ButtonVariable
                  data={data}
                  dialogFormikProps={formikProps}
                  templateData={templateData[data]}
                  formikProps={{
                    values: {
                      templateID: formikProps.values.templateID,
                    },
                  }}
                  fields={fields}
                  editState={editState}
                />
              </Grid>
            )}
          </Fragment>
        ))}
    </Paper>
  );

  function handleRenderVariable() {
    setShowVar(true);
  }

  function handleChangeTemplate(arr, { option }, reason, name, displayName) {
    setShowVar(false);

    formikProps.setValues((prevValues) => {
      const updatedValues = { ...prevValues };

      delete updatedValues[option.name];

      return {
        ...updatedValues,
        templateID: setValuesOfDropDown(prevValues.templateID),
      };
    });

    if (reason !== "removeOption") {
      axios({
        url: "/wa/template/variable/" + activeBot.ID + "/" + option._id,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          let res = response.data;
          setTemplateData((prevData) => ({
            ...prevData,
            [option.name]: response.data,
          }));

          formikProps.setValues((prev) => ({
            ...prev,
            [option.name]: {
              templateID: option._id,
              ...(res?.variables?.header?.length != 0 && {
                header_variable: Array(
                  res.template_data?.template_header?.count_of_variable
                ).fill({
                  variable_default_value: "",
                  variable_name: "",
                  variable_value: "",
                  file_name: "",
                  variable_value_type: "custom",
                }),
              }),
              ...(res?.variables?.body?.length != 0 && {
                body_variable: Array(
                  res.template_data?.template_body?.count_of_variable
                ).fill({
                  variable_default_value: "",
                  variable_name: "",
                  variable_value: "",
                  variable_value_type: "custom",
                }),
              }),
              ...(res?.variables?.button?.length != 0 && {
                button_variable: Array(
                  res.template_data?.template_button?.count_of_variable
                ).fill({
                  variable_default_value: "",
                  variable_name: "",
                  variable_value: "",
                  variable_value_type: "custom",
                }),
              }),
            },
          }));
        }
      });
    } else {
      setTemplateData((prevData) => {
        const newData = { ...prevData };
        delete newData[option.name];
        return newData;
      });
    }

    function setValuesOfDropDown(val) {
      let values = [...val];

      if (reason === "removeOption") {
        if (typeof option === "object") {
          values = values.filter((val) => val !== option._id);
        }

        if (typeof option === "string") {
          values.pop();
        }
      }
      if (reason === "selectOption") {
        values.push(option._id);
      }

      return values;
    }
  }

  function handleChange(e, name) {
    formikProps.setValues((prev) => ({
      ...prev,
      [name]: { ...prev[name], broadcastDate: e.target.value },
    }));

    var time = convertDateToBackendFormat(e.target.value);

    axios({
      url: "/broadcast/time?schedule_date=" + time,
      method: "GET",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setScheduledTime(response.data);
      }
    });
  }
}
